import { combineReducers } from 'redux'
import authReducer from './authReducer'
import themeReducer from './themeReducer'
import topicsReducer from './topicsReducer'

const rootReducer = combineReducers({
    auth: authReducer,
    theme: themeReducer,
    topics: topicsReducer,
})

export default rootReducer 